






























































import Component from 'vue-class-component';
import { VModel } from 'vue-property-decorator';
import TextField from '@/general/component/TextField.vue';
import Vue from 'vue';
import { SensorFormModel } from '@/context/sensor/model/SensorFormModel';
import MeterAutocomplete from '@/general/component/form/autocomplete/MeterAutocomplete.vue';
import SensorTagSemiAutocomplete
  from "@/general/component/form/autocomplete/SensorTagSemiAutocomplete.vue";

@Component({
  components: {
    SensorTagSemiAutocomplete,
    MeterAutocomplete,
    TextField,
  }
})
export default class SensorForm extends Vue {
  @VModel({ default: new SensorFormModel() }) model!: SensorFormModel;
}
